import "./B2BServices.css";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";

const services = [
  {
    title: "MICE",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/travel%20solution/corporate%20events.webp",
  },
  {
    title: "Events",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Home-Travel%20Solution/events-about.webp",
  },
  {
    title: "B2B Services",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/travel%20solution/B2B.webp",
  },
  {
    title: "Luxury Travel",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/travel%20solution/luxury%20travel.webp",
  },

  {
    title: "Group Travel",
    image:
      "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/travel%20solution/group%20travel.webp",
  },
  {
    title: "Solo Travel",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/travel%20solution/solo%20travel.webp",
  },
  {
    title: "Airport Transfers",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Home-Travel%20Solution/airport-transfer.webp",
  },
  {
    title: "Visa Services",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Home-Travel%20Solution/visa-services.webp",
  },
];

const B2BServices = () => {
  const navigate = useNavigate();
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const tabMap = {
    MICE: "MICE",
    Events: "Events",
    "B2B Services": "B2B Services",
    "Luxury Travel": "Luxury Travel",
    "Group Travel": "Group Travel",
    "Solo Travel": "Solo Travel",
    "Airport Transfers": "Airport Transfers",
    "Visa Services": "Visa Services",
  };

  return (
    <section className="standard-padding">
      <h1 className="heading text-center mb-4">
        Exclusive B2B Travel Solutions
      </h1>

      <div className="b2b-slider-wrapper">
        {/* ARROWS */}
        <div className="custom-prev" ref={prevRef}>
          <img src="/assets/blue-icon1.svg" alt="Prev" />
        </div>
        <div className="custom-next" ref={nextRef}>
          <img src="/assets/blue-icon2.svg" alt="Next" />
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          spaceBetween={10}
          slidesPerView={6}
          breakpoints={{
            0: { slidesPerView: 1.5 },
            480: { slidesPerView: 2.5 },
            900: { slidesPerView: 3.5 },
            1100: { slidesPerView: 4 },
            1300: { slidesPerView: 6 },
          }}
          className="b2b-grid"
        >
          {services.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="b2b-card"
                onClick={() =>
                  navigate(
                    `/about-us?tab=${encodeURIComponent(tabMap[item.title])}`,
                  )
                }
              >
                <img src={item.image} alt={item.title} />
                <div className="overlay"></div>
                <p className="b2b-card-title">{item.title}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default B2BServices;
